<app-goals-list-view [IsView]="true"></app-goals-list-view>
